// ─── Denomination Lists ─────────────────────────────────────────────────────
export var NUMBER_DENOMINATIONS = ['hundreds', 'tens', 'ones'];
export var MONEY_DENOMINATIONS = [
    'dollar',
    'halfDollar',
    'quarter',
    'dime',
    'nickel',
    'penny',
];
// ─── i18n Keys ──────────────────────────────────────────────────────────────
export var DENOMINATION_KEYS = {
    ones: 'text.ones',
    tens: 'text.tens',
    hundreds: 'text.hundreds',
    dollar: 'text.dollar',
    halfDollar: 'text.halfDollar',
    quarter: 'text.quarter',
    dime: 'text.dime',
    nickel: 'text.nickel',
    penny: 'text.penny',
};
// ─── Colors ─────────────────────────────────────────────────────────────────
export var NUMBER_COLORS = {
    numberYellow: {
        ones: '#FFFF00',
        tens: '#FFFF00',
        hundreds: '#FFFF00',
    },
    numberColored: {
        ones: '#FFFF00',
        tens: '#58CC00',
        hundreds: '#FF002B',
    },
};
// ─── Currency Images ────────────────────────────────────────────────────────
export var CURRENCY_IMAGES = {
    dollar: {
        front: './assets/images/manipulative/currency/dollarFront.svg',
        back: './assets/images/manipulative/currency/dollarBack.svg',
    },
    halfDollar: {
        front: './assets/images/manipulative/currency/halfDollarFront.svg',
        back: './assets/images/manipulative/currency/halfDollarBack.svg',
    },
    quarter: {
        front: './assets/images/manipulative/currency/quarterFront.svg',
        back: './assets/images/manipulative/currency/quarterBack.svg',
    },
    dime: {
        front: './assets/images/manipulative/currency/dimeFront.svg',
        back: './assets/images/manipulative/currency/dimeBack.svg',
    },
    nickel: {
        front: './assets/images/manipulative/currency/nickelFront.svg',
        back: './assets/images/manipulative/currency/nickelBack.svg',
    },
    penny: {
        front: './assets/images/manipulative/currency/pennyFront.svg',
        back: './assets/images/manipulative/currency/pennyBack.svg',
    },
};
// ─── Grid & Snap ────────────────────────────────────────────────────────────
export var GRID_SIZE = 55;
// Max bounding-box gap (at scale 1) for an axis-aligned drop to snap flush
// against a neighbouring piece. A quarter of a cell — the snap-to-piece path
// previously accepted a whole cell (GRID_SIZE), which pulled in pieces dropped
// well clear of the target.
export var ADJACENT_SNAP_GAP = GRID_SIZE / 4;
export var MONEY_GRIDS = {
    dollar: { cols: 10, rows: 10 },
    halfDollar: { cols: 5, rows: 10 },
    quarter: { cols: 5, rows: 5 },
    dime: { cols: 1, rows: 10 },
    nickel: { cols: 1, rows: 5 },
    penny: { cols: 1, rows: 1 },
};
// ─── Dimensions (popup creation values stored in data.dimensions) ───────────
export var PIECE_GRID = GRID_SIZE;
export var PIECE_DIMENSIONS = {
    ones: { width: PIECE_GRID, height: PIECE_GRID },
    tens: { width: PIECE_GRID, height: PIECE_GRID * 10 },
    hundreds: { width: PIECE_GRID * 10, height: PIECE_GRID * 10 },
};
export var COIN_POPUP_DIMENSIONS = {
    dollar: { width: 471, height: 198 },
    halfDollar: { width: 122, height: 122 },
    quarter: { width: 97, height: 97 },
    dime: { width: 71, height: 71 },
    nickel: { width: 82, height: 82 },
    penny: { width: 77, height: 77 },
};
export var MONEY_PIECE_DIMENSIONS = {
    dollar: { width: PIECE_GRID * 10, height: PIECE_GRID * 10 },
    halfDollar: { width: PIECE_GRID * 5, height: PIECE_GRID * 10 },
    quarter: { width: PIECE_GRID * 5, height: PIECE_GRID * 5 },
    dime: { width: PIECE_GRID, height: PIECE_GRID * 10 },
    nickel: { width: PIECE_GRID, height: PIECE_GRID * 5 },
    penny: { width: PIECE_GRID, height: PIECE_GRID },
};
// ─── Dimensions (actual render sizes used for snap calculations) ────────────
export var COIN_RENDER_DIMENSIONS = {
    dollar: { width: 471, height: 198 },
    halfDollar: { width: 122, height: 122 },
    quarter: { width: 97, height: 97 },
    dime: { width: 71, height: 71 },
    nickel: { width: 82, height: 82 },
    penny: { width: 77, height: 77 },
};
// ─── Exchange Layouts ───────────────────────────────────────────────────────
export var COIN_EXCHANGE_LAYOUT = {
    dollar: { cols: 10, overlapX: 0, overlapY: 0 },
    halfDollar: { cols: 10, overlapX: 0, overlapY: 0 },
    quarter: { cols: 2, overlapX: 0, overlapY: 0 },
    dime: { cols: 10, overlapX: 0, overlapY: 0 },
    nickel: { cols: 10, overlapX: 0.3, overlapY: 0 },
    penny: { cols: 10, overlapX: 0.3, overlapY: 0.45 },
};
export var MONEY_PIECE_EXCHANGE_LAYOUT = {
    dollar: { cols: 10, overlapX: 0, overlapY: 0 },
    halfDollar: { cols: 10, overlapX: 0, overlapY: 0 },
    quarter: { cols: 2, overlapX: 0, overlapY: 0 },
    dime: { cols: 10, overlapX: 0, overlapY: 0 },
    nickel: { cols: 10, overlapX: 0, overlapY: 0 },
    penny: { cols: 10, overlapX: 0, overlapY: 0 },
};
// ─── Limits ─────────────────────────────────────────────────────────────────
export var GLOBAL_TOTAL_LIMIT = 30;
export var NUMBER_LIMITS = {
    hundreds: 5,
    tens: 20,
    ones: 20,
};
export var MONEY_LIMITS = {
    dollar: 5,
    halfDollar: 5,
    quarter: 5,
    dime: 10,
    nickel: 10,
    penny: 25,
};
export var COIN_LIMITS = {
    dollar: 5,
    halfDollar: 5,
    quarter: 5,
    dime: 10,
    nickel: 5,
    penny: 25,
};
// ─── Button ID Helpers ──────────────────────────────────────────────────────
/** Check if a button ID matches a base NMP action (handles type suffixes like _colored, _money, _yellow) */
export var isNmpAction = function (id, action) {
    return id === action || id.startsWith(action + '_');
};
/** Base NMP action IDs that should be disabled while any piece is animating */
export var NMP_ANIMATING_ACTIONS = [
    'nmp_break',
    'nmp_link',
    'nmp_rotate',
    'nmp_flip',
    'nmp_exchange',
    'nmp_animation',
];
/** Maps denomination button IDs (all variants) to denomination strings */
export var DENOM_BTN_MAP = {
    nmp_ones: 'ones',
    nmp_ones_colored: 'ones',
    nmp_tens: 'tens',
    nmp_tens_colored: 'tens',
    nmp_hundreds: 'hundreds',
    nmp_hundreds_colored: 'hundreds',
    nmp_dollar: 'dollar',
    nmp_dollar_money: 'dollar',
    nmp_halfDollar: 'halfDollar',
    nmp_halfDollar_money: 'halfDollar',
    nmp_quarter: 'quarter',
    nmp_quarter_money: 'quarter',
    nmp_dime: 'dime',
    nmp_dime_money: 'dime',
    nmp_nickel: 'nickel',
    nmp_nickel_money: 'nickel',
    nmp_penny: 'penny',
    nmp_penny_money: 'penny',
};
/** IDs of denomination buttons that support drag-to-create */
export var DRAG_CREATE_IDS = new Set(Object.keys(DENOM_BTN_MAP));
/** Map NMP pieceType to rightConfig key in btnData.json */
export var NMP_PIECE_TYPE_CONFIG = {
    numberYellow: 'numberPiece',
    numberColored: 'numberPieceColored',
    coins: 'coinPiece',
    money: 'moneyPiece',
};
